import { fg } from '@atlaskit/platform-feature-flags/fg';

import { PrimaryProductKeys } from '../../constants/primary-product-keys';

export const isRovoJourneyIdEnabled = (primaryProduct: string | undefined): boolean =>
	(primaryProduct === PrimaryProductKeys.Confluence ||
		primaryProduct === PrimaryProductKeys.Atlas) &&
	fg('rovo_search_chat_convergence_instrumentation');

export const normalizeRovoJourneyId = (value: unknown): string | undefined =>
	typeof value === 'string' && value.length > 0 ? value : undefined;
